import * as React from "react";
const ClothesTechnicianFemale = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1080 1920"
	>
		<defs>
			<style>
				{
					".cls-corp-fem-rep-1{fill:none;}.cls-corp-fem-rep-2{clip-path:url(#clip-path-cls-corp-fem-rep);}.cls-corp-fem-rep-3{fill:#aab4b5;}.cls-corp-fem-rep-4{fill:#f5f7f7;}.cls-corp-fem-rep-5{clip-path:url(#clip-path-cls-corp-fem-rep-2);}.cls-corp-fem-rep-6{clip-path:url(#clip-path-cls-corp-fem-rep-3);}.cls-corp-fem-rep-7{fill:#676268;}.cls-corp-fem-rep-8{fill:#221e23;}.cls-corp-fem-rep-9{clip-path:url(#clip-path-cls-corp-fem-rep-4);}.cls-corp-fem-rep-10{fill:#294256;}.cls-corp-fem-rep-11{fill:#11272d;}.cls-corp-fem-rep-12{fill:#30576d;}.cls-corp-fem-rep-13,.cls-corp-fem-rep-14{fill:#fff;}.cls-corp-fem-rep-13{stroke:#11272d;stroke-miterlimit:10;stroke-width:0.5px;}"
				}
			</style>
			<clipPath id="clip-path-cls-corp-fem-rep">
				<path
					className="cls-corp-fem-rep-1"
					d="M583.12,1731s-1.66,61.6-3.31,71.87-2.5,8.8-4.95,16.43c-3.3,10.26-5,26.69,0,32.85s28.07,20.53,52.85,18.48,38.26-12.16,39.63-16.43c3.3-10.26,0-37-3.3-45.17s-9.91-22.59-11.56-28.75-6.61-34.9-8.26-53.38S583.12,1731,583.12,1731Z"
				/>
			</clipPath>
			<clipPath id="clip-path-cls-corp-fem-rep-2">
				<path
					className="cls-corp-fem-rep-1"
					d="M536,1729.82s1.65,61.6,3.3,71.87,2.5,8.8,5,16.43c3.3,10.26,4.95,26.69,0,32.85s-28.08,20.53-52.85,18.48-38.27-12.16-39.64-16.43c-3.3-10.26,0-37,3.31-45.17s9.9-22.59,11.56-28.75,6.6-34.9,8.25-53.38S536,1729.82,536,1729.82Z"
				/>
			</clipPath>
			<clipPath id="clip-path-cls-corp-fem-rep-3">
				<path
					className="cls-corp-fem-rep-1"
					d="M721.37,897.35c-6.3-56.7-29.4-84-29.4-84L561.77,847l-132.3-33.6s-23.1,42-27.3,92.4c-3.14,37.73-2.1,327.6,0,342.3s10.5,63,10.5,81.9v138.6c0,16.8,16.8,262.5,16.8,262.5s58.8,37.8,111.3,2.1c2.1-52.5-4.2-338.1-6.3-365.4s23.1-331.8,23.1-331.8H566s25.2,304.5,23.1,331.8-16.8,308.7-14.7,361.2c52.5,35.7,88.2,2.1,88.2,2.1s44.1-247.8,44.1-264.6,4.2-117.6,4.2-136.5,8.4-67.2,10.5-81.9S725.55,935,721.37,897.35Z"
				/>
			</clipPath>
			<clipPath id="clip-path-cls-corp-fem-rep-4">
				<path
					className="cls-corp-fem-rep-1"
					d="M773.87,620c-6.8-27.18-18.9-136.5-18.9-136.5s-4.2-29.4-25.2-44.1-105-50.4-113.4-65.1c2.1-4.2,12.6-10.5,18.9-14.7C631.07,330.15,601,324,601,324s2,42.9,2,45,5,5.25,5,7.35c-12.6,35.7-46.2,29.4-46.2,29.4s-33.6,6.3-46.2-29.4C517,375,521,371.1,521,369s2-45,2-45-30.53,6.15-34.73,35.55c6.3,4.2,16.8,10.5,18.9,14.7-8.4,14.7-92.4,50.4-113.4,65.1s-25.2,44.1-25.2,44.1-12.1,109.32-18.9,136.5C335,678.75,314,941.25,314,941.25s27.3,27.3,63,8.4c2.1-44.1,27.3-172.2,35.7-195.3s16.8-149.1,16.8-149.1,21,102.9,16.8,128.1-21,77.7-23.1,86.1c14.7,21,67.2,39.9,138.6,39.9s123.9-18.9,138.6-39.9c-2.1-8.4-18.9-60.9-23.1-86.1s16.8-128.1,16.8-128.1,8.4,126,16.8,149.1,33.6,151.2,35.7,195.3c35.7,18.9,63-8.4,63-8.4S788.57,678.75,773.87,620Z"
				/>
			</clipPath>
		</defs>
		<title>{"habit r\xE9paratrice f"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-corp-fem-rep-1" width={1080} height={1920} />
		</g>
		<g id="r\xE9paratrice_f" data-name="r\xE9paratrice f">
			<g className="cls-corp-fem-rep-2">
				<path
					className="cls-corp-fem-rep-3"
					d="M583.12,1731s-1.66,61.6-3.31,71.87-2.5,8.8-4.95,16.43c-3.3,10.26-5,26.69,0,32.85s28.07,20.53,52.85,18.48,38.26-12.16,39.63-16.43c3.3-10.26,0-37-3.3-45.17s-9.91-22.59-11.56-28.75-6.61-34.9-8.26-53.38S583.12,1731,583.12,1731Z"
				/>
				<path
					className="cls-corp-fem-rep-4"
					d="M569.9,1852.17s-4.95-20.53,1.66-30.8,23.12-24.64,47.89-26.69,44.59,6.16,51.19,28.74-6.6,67.76-6.6,67.76l-94.14-20.53Z"
				/>
				<path
					className="cls-corp-fem-rep-4"
					d="M602.93,1735.13s1.65,61.6-3.3,73.92,38-4.11,38-4.11-8.25-30.8-8.25-78C614.49,1731,602.93,1735.13,602.93,1735.13Z"
				/>
			</g>
			<g className="cls-corp-fem-rep-5">
				<path
					className="cls-corp-fem-rep-3"
					d="M536,1729.82s1.65,61.6,3.3,71.87,2.5,8.8,5,16.43c3.3,10.26,4.95,26.69,0,32.85s-28.08,20.53-52.85,18.48-38.27-12.16-39.64-16.43c-3.3-10.26,0-37,3.31-45.17s9.9-22.59,11.56-28.75,6.6-34.9,8.25-53.38S536,1729.82,536,1729.82Z"
				/>
				<path
					className="cls-corp-fem-rep-4"
					d="M549.17,1851s5-20.53-1.65-30.8-23.12-24.64-47.89-26.69-44.59,6.16-51.2,28.74S455,1890,455,1890l94.13-20.53Z"
				/>
				<path
					className="cls-corp-fem-rep-4"
					d="M516.14,1733.93s-1.65,61.6,3.3,73.92-38-4.11-38-4.11,8.26-30.8,8.26-78C504.58,1729.82,516.14,1733.93,516.14,1733.93Z"
				/>
			</g>
			<g className="cls-corp-fem-rep-6">
				<path
					className="cls-corp-fem-rep-7"
					d="M727.67,907.85c0-46.2-21-84-21-84L561.77,847l-144.9-23.1s-18.9,35.7-18.9,81.9c0,37.86,2.1,327.6,4.2,342.3s10.5,63,10.5,81.9-4.2,119.7-4.2,136.5,48.3,264.6,48.3,264.6,35.7,31.5,88.2-4.2c2.1-52.5-8.4-331.8-10.5-359.1s23.1-331.8,23.1-331.8H566s25.2,304.5,23.1,331.8-12.6,308.7-10.5,361.2c44.1,31.5,84,2.1,84,2.1s52.5-247.8,52.5-264.6-4.2-117.6-4.2-136.5,8.4-67.2,10.5-81.9S727.67,945.71,727.67,907.85Z"
				/>
				<path
					className="cls-corp-fem-rep-8"
					d="M719.27,1306.85s-33.6,39.9-100.8,10.5c-4.2-31.5-44.1-281.4-44.1-281.4l-8.4-4.2h-8.4l-8.4,4.2s-39.9,249.9-44.1,281.4c-67.2,29.4-100.8-10.5-100.8-10.5s-52.5,92.4,4.46,146.58,127.09,0,127.09,0L561.77,1036l26,417.48s70.12,54.19,127.08,0S719.27,1306.85,719.27,1306.85Z"
				/>
				<path
					className="cls-corp-fem-rep-8"
					d="M608,855.35s12.6,31.5,69.3,27.3c48.3-21,21-63,21-63Z"
				/>
				<path
					className="cls-corp-fem-rep-8"
					d="M514.86,855.35s-12.6,31.5-69.3,27.3c-48.3-21-21-63-21-63Z"
				/>
			</g>
			<path
				className="cls-corp-fem-rep-8"
				d="M404.26,1265.35s30.62-23.85,36.74-36.54-10.88-176.26-10.88-176.26l-29.63-6.36s-10,25.81-9.94,30,8.43,2,8.43,2-10.5,149.26-6.13,161.8A195.73,195.73,0,0,0,404.26,1265.35Z"
			/>
			<path
				className="cls-corp-fem-rep-8"
				d="M718.91,1265.47s-30.38-24.16-36.38-36.91,12.61-176.15,12.61-176.15l29.69-6.06s9.75,25.91,9.65,30.11-8.45,1.9-8.45,1.9,9,149.36,4.54,161.85A195.55,195.55,0,0,1,718.91,1265.47Z"
			/>
			<g className="cls-corp-fem-rep-9">
				<path
					className="cls-corp-fem-rep-10"
					d="M773.87,620c-6.8-27.18-18.9-136.5-18.9-136.5s-4.2-29.4-25.2-44.1-105-50.4-113.4-65.1c2.1-4.2,12.6-10.5,18.9-14.7-4.2-29.4-33.6-35.7-33.6-35.7s.39,43.27,1.33,45.15,4,5,5,7.35c-12.6,35.7-46.2,29.4-46.2,29.4s-33.6,6.3-46.2-29.4c1.43-2.35,4.2-4.2,4.2-6.3s2.1-46.2,2.1-46.2-29.4,6.3-33.6,35.7c6.3,4.2,16.8,10.5,18.9,14.7-8.4,14.7-92.4,50.4-113.4,65.1s-25.2,44.1-25.2,44.1-12.1,109.32-18.9,136.5C335,678.75,314,941.25,314,941.25s27.3,27.3,63,8.4c2.1-44.1,27.3-172.2,35.7-195.3s16.8-149.1,16.8-149.1,21,102.9,16.8,128.1-21,77.7-23.1,86.1c14.7,21,67.2,39.9,138.6,39.9s123.9-18.9,138.6-39.9c-2.1-8.4-18.9-60.9-23.1-86.1s16.8-128.1,16.8-128.1,8.4,126,16.8,149.1,33.6,151.2,35.7,195.3c35.7,18.9,63-8.4,63-8.4S788.57,678.75,773.87,620Z"
				/>
				<path
					className="cls-corp-fem-rep-11"
					d="M480.92,356.4s0-4.2,6.3-4.2c14.7,0,26.25,13.65,33.6,21,6.88,6.89,4.2-50.4,4.2-50.4l-48.3,12.6Z"
				/>
				<path
					className="cls-corp-fem-rep-11"
					d="M641,356.4s0-4.2-6.3-4.2c-14.7,0-26.25,13.65-33.6,21-6.88,6.89-4.2-50.4-4.2-50.4l48.3,12.6Z"
				/>
				<path
					className="cls-corp-fem-rep-11"
					d="M674.52,498.31c-30.76-11.71-111.7-11.71-111.7-11.71s-80.94,0-111.7,11.71,10-.05,27.52-2.93c17.81-2.92,56.66-5.85,84.18-5.85s66.37,2.93,84.18,5.85C664.52,498.26,705.27,510,674.52,498.31Z"
				/>
				<path
					className="cls-corp-fem-rep-12"
					d="M674.52,496.21c-30.76-11.71-111.7-11.71-111.7-11.71s-80.94,0-111.7,11.71,10,0,27.52-2.93c17.81-2.92,56.66-5.85,84.18-5.85s66.37,2.93,84.18,5.85C664.52,496.16,705.27,507.92,674.52,496.21Z"
				/>
				<rect
					className="cls-corp-fem-rep-13"
					x={560.72}
					y={450.9}
					width={2.1}
					height={445.2}
				/>
				<path
					className="cls-corp-fem-rep-14"
					d="M561.77,395.25s-52.5-18.9-35.7-4.2,35.7,59.85,35.7,59.85,18.9-45.15,35.7-59.85S561.77,395.25,561.77,395.25Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesTechnicianFemale;
